import {http} from '../lib/http/request';

const uploadProjectScreenshot = (id, blob) => {
    if (!blob) return Promise.resolve(null);
    const formData = new FormData();
    formData.append('file', blob, id+'.png');
    formData.append('id', id);
    return http.put("/scratchProject/screenshot",formData)
};

export default uploadProjectScreenshot;
